import './registerCards';
import type { ModuleRoute } from '../types';
import { DomainsPage } from './DomainsPage';
import { IdChecksPage } from './IdChecks';
import { Navigate } from 'react-router';
import { WalletPage } from './Wallet';
import { WizardPage } from './WizardPage';

/** Pages of this area (getting-started wizard, custom domains, ID check cards and DPIA confirmation, wallet settings). Owned by Phase 4 task W31; only that task edits files in this folder (W32 wires it last). */
export const routes: ModuleRoute[] = [
  { path: '/manage/setup', element: <WizardPage />, permission: 'account.manage' },
  { path: '/manage/domains', element: <DomainsPage />, permission: 'account.manage' },
  { path: '/manage/id-checks', element: <IdChecksPage />, permission: 'id_checks.manage' },
  { path: '/manage/wallet', element: <WalletPage />, permission: 'wallet.manage' },
  { path: '/platform/wallet', element: <Navigate to="/platform/settings?tab=wallet" replace />, permission: 'platform.settings_manage', area: 'platform' },
];
